<mat-card appearance="outlined" fxFlex="100">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
    <mat-card-title>{{parentType}} Mailing Addresses</mat-card-title>

    @if (!viewOnly) {
      <button mat-fab color="primary" class="addButton" (click)="addClicked()" matTooltip="Add Mailing Address" tabindex="-1">
        <mat-icon>add</mat-icon>
      </button>
    }
  </mat-card-header>

  <mat-card-content [formGroup]="cardForm">
    <mailing-address-list [mailingAddresses]="mailingAddresses" [usages]="usages" [viewOnly]="viewOnly">
    </mailing-address-list>
  </mat-card-content>

  <mat-card-actions align="end">
    <button mat-button (click)="cancelClicked()" telemetry="Submission-MailingAddressCancel">
      Cancel
    </button>
    @if (!viewOnly) {
      <button mat-button [disabled]="invalid" (click)="doneClicked()" telemetry="Submission-MailingAddressDone">
        Done
      </button>
    }
  </mat-card-actions>
</mat-card>